import { IChangeGamePositionContext } from './changeGamePositionContext';

export enum ChangeGamePositionActionTypes {
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	SET_ID_RESTAURANT = 'SET_ID_RESTAURANT',
	RESET_SELECTED_CONTROLS = 'RESET_SELECTED_CONTROLS',
	SET_POSITIONS_DATA = 'SET_POSITIONS_DATA',
	REORDER_ITEMS = 'REORDER_ITEMS',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SET_VISIBLE_ADDITIONAL_RESTAURANTS_MODAL = 'SET_VISIBLE_ADDITIONAL_RESTAURANTS_MODAL',
	TOGGLE_APPLY_TO_ONE = 'TOGGLE_APPLY_TO_ONE',
	SET_ADDITIONAL_RESTAURANTS = 'SET_ADDITIONAL_RESTAURANTS',
	SET_FETCHED_RESTAURANTS = 'SET_FETCHED_RESTAURANTS',
}

interface ISetIDCustomer {
	type: ChangeGamePositionActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: IChangeGamePositionContext['IDSelectedCustomer'];
	};
}

interface ISetIDRestaurant {
	type: ChangeGamePositionActionTypes.SET_ID_RESTAURANT;
	payload: {
		IDSelectedRestaurant: IChangeGamePositionContext['IDSelectedRestaurant'];
	};
}

interface IResetSelectedControls {
	type: ChangeGamePositionActionTypes.RESET_SELECTED_CONTROLS;
}

interface ISetPositionsData {
	type: ChangeGamePositionActionTypes.SET_POSITIONS_DATA;
	payload: {
		positionsData: IChangeGamePositionContext['positionsData'];
	};
}

interface IChangeTypeOfModalWindow {
	type: ChangeGamePositionActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IChangeGamePositionContext['typeOfModalWindow'];
	};
}

interface ISetVisibleAdditionalRestaurantsModal {
	type: ChangeGamePositionActionTypes.SET_VISIBLE_ADDITIONAL_RESTAURANTS_MODAL;
	payload: {
		isVisibleAdditionalRestaurantsModal: IChangeGamePositionContext['isVisibleAdditionalRestaurantsModal'];
		isApplyToOne: IChangeGamePositionContext['isApplyToOne'];
		selectedAdditionalRestaurants: IChangeGamePositionContext['selectedAdditionalRestaurants'];
	};
}

interface IToggleApplyToOne {
	type: ChangeGamePositionActionTypes.TOGGLE_APPLY_TO_ONE;
}

interface ISetAdditionalRestaurants {
	type: ChangeGamePositionActionTypes.SET_ADDITIONAL_RESTAURANTS;
	payload: {
		selectedAdditionalRestaurants: IChangeGamePositionContext['selectedAdditionalRestaurants'];
	};
}

interface ISetFetchedRestaurants {
	type: ChangeGamePositionActionTypes.SET_FETCHED_RESTAURANTS;
	payload: {
		fetchedRestaurants: IChangeGamePositionContext['fetchedRestaurants'];
	};
}

export type TChangeGamePositionActions =
	| ISetIDCustomer
	| ISetIDRestaurant
	| IResetSelectedControls
	| ISetPositionsData
	| IChangeTypeOfModalWindow
	| ISetVisibleAdditionalRestaurantsModal
	| IToggleApplyToOne
	| ISetAdditionalRestaurants
	| ISetFetchedRestaurants;
